"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const pulse_components_1 = require("@pcs/pulse-components");
const PulseBryntumGrid_1 = __importDefault(require("@pcs/pulse-components/PulseBryntumGrid"));
const clsx_1 = __importDefault(require("clsx"));
const utilities_1 = __importDefault(require("jsAssets/utilities"));
const lodash_1 = require("lodash");
const moment_1 = __importDefault(require("moment"));
const react_1 = __importStar(require("react"));
const helper_1 = require("../../../helper");
const link_reviews_types_1 = require("./link-reviews-types");
const styles_modules_less_1 = __importDefault(require("./styles.modules.less"));
const URL_ENDPOINT = `${helper_1.URLS.app}api/round-stages`;
const REVIEW_GRID_PAGE_SIZE = 5;
const DEFAULT_AJAX_STORE_PARAMS = {
    jq: link_reviews_types_1.REVIEW_GRID_JQ,
};
const columnConfigs = [
    {
        field: 'source_img',
        text: '',
        align: 'center',
        width: 60,
        sortable: false,
        resizable: false,
        renderer: ({ record }) => {
            const { source } = record.data;
            if (source && source.type === 'asset' && source.asset) {
                return (react_1.default.createElement("img", { src: `${helper_1.URLS.pulse}openpreview.php?format=thumb&assetid=${source.asset.id}`, alt: source.asset.title }));
            }
            return record.round_thumbnail_link ? (react_1.default.createElement("img", { src: record.round_thumbnail_link })) : (react_1.default.createElement("i", { className: "fal fa-browser" }));
        },
    },
    {
        field: 'round_title',
        text: 'REVIEW ROUND TITLE',
        width: 500,
        draggable: false,
    },
    {
        field: 'round_number',
        text: 'ROUND',
        align: 'center',
        width: 80,
        draggable: false,
    },
    {
        field: 'created_at',
        text: 'DATE CREATED',
        width: 180,
        draggable: false,
        renderer: ({ value }) => {
            return value ? (0, moment_1.default)(value).format('DD/MM/YYYY') : '';
        },
    },
];
const LinkReviews = ({ isOpen, closeModal, ticketId, jobId, jobName, onLinkReview, }) => {
    const [selectedProject, setSelectedProject] = (0, react_1.useState)({ label: jobName, value: jobId });
    const gridRef = (0, react_1.useRef)(null);
    const [canLinkReview, setCanLinkReview] = (0, react_1.useState)(false);
    const onChangeProjectSelect = (value) => {
        const gridInstance = gridRef.current.instance;
        if (value.projectId) {
            setSelectedProject(value.projectId);
            if (gridInstance) {
                const { store: gridAjaxStore } = gridInstance;
                // add project filter after selected
                const params = {
                    ...gridAjaxStore.params,
                    ...(0, helper_1.filterParams)({
                        job_id: [value.projectId.value],
                    }),
                };
                gridAjaxStore.setConfig({ params });
                gridAjaxStore.loadPage(1);
            }
        }
        else {
            setSelectedProject(undefined);
            if (gridInstance) {
                const { store: gridAjaxStore } = gridInstance;
                const params = {
                    ...gridAjaxStore.params,
                };
                // reset filter when remove project
                Object.keys(params).forEach((key) => {
                    if (key === 'filter[job_id][]') {
                        delete params[key];
                    }
                });
                gridAjaxStore.setConfig({ params });
                gridAjaxStore.loadPage(1);
            }
        }
    };
    const ajaxStoreConfig = (0, react_1.useMemo)(() => {
        return {
            autoLoad: true,
            readUrl: URL_ENDPOINT,
            pageSize: REVIEW_GRID_PAGE_SIZE,
            params: {
                ...DEFAULT_AJAX_STORE_PARAMS,
                'filter[job_id][]': [jobId],
                'filter[excluded_ticket_id][]': [ticketId],
            },
            pageParamName: 'page[number]',
            pageSizeParamName: 'page[per_page]',
            responseTotalProperty: 'page.total',
            listeners: {
                sort: ({ source: ajaxStore, sorters }) => {
                    // Handle sorting
                    if (ajaxStore) {
                        const { params: currentParams } = ajaxStore;
                        const { ascending, field } = sorters[0];
                        if (field) {
                            const params = {
                                ...currentParams,
                                sort: ascending
                                    ? (0, lodash_1.get)(link_reviews_types_1.FIELDS_TO_COLUMNS, field, '')
                                    : `-${(0, lodash_1.get)(link_reviews_types_1.FIELDS_TO_COLUMNS, field, '')}`,
                            };
                            ajaxStore.setConfig({ params });
                            ajaxStore.load({ params });
                        }
                    }
                },
            },
        };
    }, [jobId, ticketId]);
    const onChangeSelectReview = (e) => {
        setCanLinkReview(!!e.selection.length);
    };
    const searchReview = (text) => {
        const gridInstance = gridRef.current.instance;
        if (gridInstance) {
            const { store: gridAjaxStore } = gridInstance;
            const params = {
                ...gridAjaxStore.params,
                ...(0, helper_1.filterParams)({
                    qsearch: text,
                }),
            };
            gridAjaxStore.setConfig({ params });
            gridAjaxStore.loadPage(1);
        }
    };
    const debounceFn = (0, react_1.useCallback)((0, lodash_1.debounce)(searchReview, 500), []);
    const handleChangeInput = (e) => {
        debounceFn(e.target.value);
    };
    const handleSubmitLinkReviews = async () => {
        const gridInstance = gridRef.current.instance;
        if (gridInstance) {
            const roundIds = gridInstance.selectedRecords.map((record) => record.data.round_id);
            await Promise.all(roundIds.map(async (roundId) => {
                await pulse_components_1.v2Endpoint.post(`${helper_1.URLS.app}api/rounds/${roundId}/tickets`, {
                    ticket_ids: [ticketId],
                });
            }))
                .then(() => {
                utilities_1.default.notification.success('Link review(s) to task successfully');
                closeModal();
                const reloadGridEvent = new CustomEvent('reload-review-grid', {
                    detail: {
                        status: 200,
                    },
                });
                document.dispatchEvent(reloadGridEvent);
                onLinkReview();
            })
                .catch(() => {
                utilities_1.default.notification.danger('Link review(s) to task failed');
            });
        }
    };
    return (react_1.default.createElement(pulse_components_1.PulseModalBase, { open: isOpen, onModalClose: closeModal, onConfirmClick: handleSubmitLinkReviews, classes: {
            dialog: {
                paper: styles_modules_less_1.default['modal-root'],
            },
            footer: {
                root: [styles_modules_less_1.default['modal-footer__root']],
                cancel: [styles_modules_less_1.default['modal-footer__cancel']],
                confirm: !canLinkReview
                    ? [styles_modules_less_1.default['modal-footer__confirm--disabled']]
                    : [],
            },
        }, footerConfirmText: "Link reviews", PulseModalFooterProps: {
            confirmIconClasses: 'fal fa-link',
            confirmDisabled: !canLinkReview,
        }, PulseModalHeaderProps: {
            classes: {
                root: styles_modules_less_1.default['modal-header__root'],
                titleContainer: styles_modules_less_1.default['modal-header__ctn'],
                titlePrimary: styles_modules_less_1.default['modal-header__title'],
                closeBtn: styles_modules_less_1.default['modal-header__closeBtn'],
            },
            headerIconClasses: (0, clsx_1.default)('fal fa-link', styles_modules_less_1.default['modal-header__icon']),
        }, headerPrimaryText: "Link reviews to task", footer: true },
        react_1.default.createElement("div", { className: styles_modules_less_1.default['link-reviews__ctn'] },
            react_1.default.createElement("div", { className: styles_modules_less_1.default['link-reviews__filter'] },
                react_1.default.createElement(pulse_components_1.PulseProjectsSelect, { classes: {
                        selectContainer: styles_modules_less_1.default['link-review-select__select-container'],
                    }, labelName: "Select project", minCharacters: 3, valueChangeHandler: onChangeProjectSelect, value: selectedProject }),
                react_1.default.createElement(pulse_components_1.PulseInput, { label: "Search", InputBaseProps: {
                        onChange: handleChangeInput,
                        classes: {
                            root: styles_modules_less_1.default['filter-input__root'],
                            input: styles_modules_less_1.default['filter-input__input'],
                        },
                        placeholder: 'Search for Review Title or Stage Name...',
                        startAdornment: (react_1.default.createElement("i", { className: (0, clsx_1.default)('fal fa-search', styles_modules_less_1.default['filter-input__icon']) })),
                    } })),
            (0, react_1.useMemo)(() => (react_1.default.createElement(PulseBryntumGrid_1.default, { ref: gridRef, onSelectionChange: onChangeSelectReview, gridProps: {
                    columns: columnConfigs,
                    sortFeature: true,
                    rowHeight: 48,
                    cellMenuFeature: false,
                    headerMenuFeature: true,
                    selectionMode: {
                        includeParents: false,
                    },
                }, ajaxStoreConfig: ajaxStoreConfig, selectable: true, paginate: true })), [ajaxStoreConfig]))));
};
exports.default = LinkReviews;
